import React, {Component} from "react";
import Header from "../../../Containers/Header/Header";
import Footer from "../../../Containers/Footer/index";
import PageTopMenu from "../../../Containers/PageTopMenu";
import CategoryIn from "../../../Buttons/CategoryIn/index";
import * as HomeworkService from "../../../../services/Student/HomeworkService";
import Loading from "../../../Containers/Loading";
import * as Utils from "../../../Utils";

class Reading extends Component {
    state = {
        // loading
        isLoadingHide: true
    };

    componentDidMount = () => {
        this._isMounted = true;
        const params = new URLSearchParams(this.props.location.search);
        this.getReadingHomework(Utils.getDate(), params.get('section'), params.get('title'));
    };

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    getReadingHomework = (date, section, title) => {
        const that = this;
        HomeworkService.getReadingHomework(date, section, title).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    if (that._isMounted) {
                        that.setState({
                            title: response.data.data.reading.title,
                            section: response.data.data.reading.section
                        });
                    }
                } else {
                    window.location.href = '/app/homework';
                }
            } else {
                console.log(response);
                alert('LOGIN ERROR');
            }
        }).catch(response => {
            console.log(response);
            alert('SERVER ERROR');
        });
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }
        const {title, section} = this.state;
        return (
            <div className="beaconWrapper">
                <Header/>
                <div className="allconWrapper">
                    <div className="contentsWrapper">
                        <h2 className="screenOut">오늘의 Reading 숙제</h2>
                        <PageTopMenu/>
                        <div className="pageContents">
                            <CategoryIn categoryState="on" categoryName="reading" color="green" btnName="START"
                                        link="/app/readinghomework" title={title} section={section}/>
                            {/*<ReadingContent></ReadingContent>*/}
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default Reading;



// WEBPACK FOOTER //
// ./src/components/Pages/Student/Reading/index.js